import React from 'react';
import InfiniteFeed from '../InfiniteFeed/InfiniteFeed.component';
import OttCard from './OttCard.component';
import useInfiniteFeed from '../../hooks/useInfiniteFeed';
import { ottFeed } from '../../services/ottFeed';

const GRID = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-6';

const NewOnOtt = () => {
  const feed = useInfiniteFeed({ kind: 'movie', fetcher: ottFeed.fetch, sort: 'newest' });

  if (!feed.isInitialLoading && feed.items.length === 0) return null;

  return (
    <section className="mb-14">
      <header className="mb-6 flex items-end justify-between gap-4 px-1">
        <div>
          <div className="flex items-center gap-3 mb-1.5">
            <span className="w-1.5 h-7 bg-emerald-400 rounded-full" aria-hidden="true" />
            <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-white tracking-tight">
              New on OTT
            </h2>
          </div>
          <p className="text-gray-400 text-xs sm:text-sm pl-[1.125rem]">
            Bollywood, South &amp; Hollywood releases that just landed on streaming — Hindi playback,
            newest OTT date first, NEW badge for 5 days.
          </p>
        </div>
        <span className="hidden sm:inline-block text-[11px] font-bold text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 px-3 py-1.5 rounded-full whitespace-nowrap">
          Hindi playback · OTT
        </span>
      </header>

      <InfiniteFeed
        items={feed.items}
        status={feed.status}
        error={feed.error}
        hasMore={feed.hasMore}
        totalResults={feed.totalResults}
        isInitialLoading={feed.isInitialLoading}
        isLoadingMore={feed.isLoadingMore}
        onLoadMore={feed.loadMore}
        onRetry={feed.retry}
        label="New OTT releases"
        noun="releases"
        skeletonCount={6}
        gridClassName={GRID}
        renderItem={(item) => <OttCard {...item} />}
      />
    </section>
  );
};

export default NewOnOtt;
